// @ai-generated 2026-08-27T08:12:58+00:00 by malte.ulfers@tngtech.com using Claude Opus 5 (1M context)
import { useSession } from '@Contexts/session';
import type { ReactToolCallRenderer } from '@copilotkit/react-core/v2';
import { readValidationOutcome } from '@utils/toolCallEnvelope';
import { RejectedRecordTable } from './RejectedRecordTable';
import { ToolCallCardShell } from './ToolCallCardShell';
import { resolveToolCallState } from './toolCallStatus';
import { summarizeValidation, VALIDATION_TOOLS, type ValidationTool } from './validationTools';

/**
 * A ruleset validation in the transcript. Rows come from the payload rather than the failure prose,
 * because only the payload carries the ids the links need; it survives a rejected call on purpose.
 */
function ValidationToolCallCard({ tool, result, status }: { tool: ValidationTool; result: unknown; status: unknown }) {
    const {
        current: { subpath },
    } = useSession();
    const state = resolveToolCallState(status, result);
    const outcome = state.isRunning ? undefined : readValidationOutcome(result);

    if (outcome === undefined) {
        // No verdict to read — fall back to the shell, which explains a failure from the messages.
        return <ToolCallCardShell title={tool.title} state={state} result={result} />;
    }

    const hasRejections = outcome.hardFailed.length + outcome.softFailed.length > 0;

    return (
        <ToolCallCardShell
            title={tool.title}
            summary={summarizeValidation(outcome, tool)}
            state={state}
            result={result}
            {...(hasRejections
                ? { body: <RejectedRecordTable outcome={outcome} tool={tool} subpath={subpath} /> }
                : {})}
        />
    );
}

/** Spread before the wildcard fallback, like the record-listing cards. */
export const ChatValidationToolCallCards: ReactToolCallRenderer[] = VALIDATION_TOOLS.map((tool) => ({
    name: tool.name,
    render: ({ result, status }) => <ValidationToolCallCard tool={tool} result={result} status={status} />,
}));
